<div>
  <div class="designer-row-editor">
    <div class="designer-row-editor-header">
      <button (click)="handleAddNewRowClick($event)" class="designer-row-editor-header-button" matFab extended >
        <mat-icon>add</mat-icon>
        Create New Row
      </button>
    </div>
  </div>
</div>